var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ik-data-table',{attrs:{"entity-name":"DailyReport","model":_vm.model,"required-date-value":_vm.$parent.dateRange,"use-action":false,"use-default-action":false,"icon":"mdi-cards"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }